import CryptoJS from "crypto-js";

export const IsNotValue = [
  null,
  "null",
  "Null",
  undefined,
  "undefined",
  "+undefined",
  "",
  "<p></p>\n",
  "Invalid Date",
  "Invalid date"
];

export const decryptMyData = (data) => {
  const bytes = CryptoJS.AES.decrypt(data, "lvb-secret-key@india");
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

export const gender = [
  // { label: "All", value: -1 },
  { label: "Select Gender", value: 0 },
  { label: "Male", value: 1 },
  { label: "Female", value: 2 }
];
export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  boxShadow: 10,
  borderRadius: "10px",
  p: 2
};

export const displayFilter = [
  { label: "All", value: -1 },
  { label: "Display On", value: 1 },
  { label: "Display Off", value: 0 }
];

export const statusLabel = [
  { label: "All", value: -1 },
  { label: "Pending", value: 0 },
  { label: "Received", value: 1 }
];

export const LeadSearchTypeOptions = [
  { value: -1, label: "All Lead" },
  { value: 0, label: "Other Lead" },
  { value: 1, label: "Visitor Lead" },
  { value: 2, label: "Member Renewal Lead" },
  { value: 3, label: "Confirm Member Lead" },
  { value: 4, label: "Visitor Present" },
  { value: 5, label: "Visitor Absent" }
];

export const leadDetailsModelStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  boxShadow: 10,
  borderRadius: "10px"
};

export const leadFollowupStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 10,
  borderRadius: "10px",
  padding: "10px"
};

export const updateFrom = ["From Setting", "From Records", "From Chapter", "From Invoice Setting", "From Leave Setting"];

export const invoiceToTypeOptions = [
  { value: 0, label: "Member" },
  { value: 1, label: "Customer" }
];

export const invoiceFilterFields = {
  i_to_type: -1,
  i_type: -1,
  start_date: null,
  end_date: null,
  search: "",
  state_id: "",
  city_id: ""
};

export const invoiceTypeFilter = [
  { label: "All", value: -1 },
  { label: "Not Generated", value: 0 },
  { label: "Generated", value: 1 },
  { label: "Expired Invoice", value: 2 }
];
